import React from "react";

const Counter = ({ title, count, icon, iconBg }) => {
  return (
    <div className="info-box bg-white">
      <span className={`info-box-icon ${iconBg}`} style={{ marginTop: "7px" }}>
        <i className="material-icons">{icon}</i>
      </span>
      <div className="info-box-content">
        <span className="info-box-text">{title}</span>
        <span className="info-box-number">{count}</span>
      </div>
    </div>
  );
};

export default Counter;
